import { useAuthStore } from '../store/auth';

export default function Dashboard() {
    const { admin } = useAuthStore();

    return (
        <div>
            <div className="page-header">
                <h2>Dashboard</h2>
                <p style={{ color: 'var(--text-secondary)' }}>
                    Bienvenido, {admin?.fullName || admin?.email}
                </p>
            </div>

            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Provincias</h3>
                    <div className="value">24</div>
                </div>
                <div className="stat-card">
                    <h3>Municipios</h3>
                    <div className="value">156</div>
                </div>
                <div className="stat-card">
                    <h3>Usuarios Activos</h3>
                    <div className="value">12.4k</div>
                </div>
                <div className="stat-card">
                    <h3>Reclamos Hoy</h3>
                    <div className="value">847</div>
                </div>
            </div>

            <div className="card">
                <h3 style={{ marginBottom: '1rem' }}>Actividad Reciente</h3>
                <p style={{ color: 'var(--text-secondary)' }}>
                    Los datos se cargarán desde la API cuando esté conectada.
                </p>
            </div>
        </div>
    );
}
